import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const QuestionIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0751 22.3833V19.3527H12.9251V22.3833H10.0751ZM11.5001 5.23051C9.65651 5.23051 8.15463 6.76503 8.05533 8.66106H5.20288C5.3029 5.0637 8.09228 2.19995 11.5001 2.19995C14.9708 2.19995 17.8001 5.17043 17.8001 8.86106C17.8001 10.9108 16.646 12.0372 15.4269 13.1631L15.3155 13.2659C14.1816 14.3113 13.0087 15.3926 12.9294 17.2375H10.0773C10.105 15.9779 10.3941 15.0536 10.8103 14.3275C11.2497 13.561 11.8375 13.0029 12.4409 12.4987C12.5839 12.3792 12.729 12.2622 12.8735 12.1456L12.8736 12.1455C13.9262 11.2966 14.9501 10.4708 14.9501 8.86106C14.9501 6.87413 13.4081 5.23051 11.5001 5.23051Z"
          fill="#FFB155"
        />
      </svg>
    )
  },
)
